"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormController
} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { Debounce } from "vue-debounce-decorator";
import chromeIcon from "@/assets/style/icon/chrome.svg";
import chromeActiveIcon from "@/assets/style/icon/chrome_active.svg";
import firefoxIcon from "@/assets/style/icon/firefox.svg";
import firefoxActiveIcon from "@/assets/style/icon/firefox_active.svg";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
export class EditPrivacyModeForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.browser_core = "chrome";
    this.privacy_mode = true;
    this.choose_list = [];
  }
}
let PrivacyModeDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.controller = new EditPrivacyModeForm();
    this.dialogLoading = false;
    this.shopItem = null;
    this.version = null;
    this.showFirefox = false;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(shop) {
    return __async(this, null, function* () {
      yield this.getVersion();
      this.shopItem = shop;
      this.dialog.visible = true;
    });
  }
  getVersion() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.local/update/version`);
        this.version = response.data.os;
        if (response.data.os.name === "Windows" && response.data.os.arch === "x64") {
          this.showFirefox = true;
        } else {
          this.showFirefox = false;
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  changeBrowserCore() {
    this.controller.choose_list = [];
  }
  submit() {
    return __async(this, null, function* () {
      try {
        let version = this.version.version.split("(")[0];
        if (version === "0" || version === "7") {
          yield UiConfirm.warnconfirm(
            this.$t("privacy_mode.win_7_tip_content"),
            this.$t("privacy_mode.win_7_tip_title"),
            {
              confirmButtonText: this.$t("privacy_mode.confirm"),
              cancelButtonText: this.$t("privacy_mode.cancel"),
              iconClass: "el-icon-warning"
            }
          );
        }
        let flag = false;
        try {
          yield API.get(
            `api://base.local/storages/preference/mainExtensionVersion`
          );
          flag = true;
        } catch (error) {
          flag = false;
        }
        if (flag) {
          let submitData = {
            shop_id: this.shopItem.shopOldId,
            vd_id: this.shopItem.vd.oldId,
            new_vd: this.shopItem.vd.id,
            new_shop_id: this.shopItem.id,
            launcher_value: {
              // 浏览器核心
              browser_core: this.controller.browser_core,
              // 是否是隐私模式
              is_hide: this.controller.privacy_mode,
              // 选择的cookie和插件加载模式
              choose_modes: this.controller.choose_list
            }
          };
          if (this.controller.choose_list.includes("cookie")) {
            submitData.launcher_value.load_cookie = true;
          } else {
            submitData.launcher_value.load_cookie = false;
          }
          if (this.controller.choose_list.includes("extension")) {
            submitData.launcher_value.load_extension = true;
          } else {
            submitData.launcher_value.load_extension = false;
          }
          yield API.post(`api://base.local/websockets/main`, {
            model: "virtualBrowser.hide_launcher_new",
            value: submitData
          });
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: this.shopItem.vd.oldId,
              shop_id: this.shopItem.shopOldId,
              new_vd: this.shopItem.vd.id,
              new_shop_id: this.shopItem.id
            }
          });
        } else {
          let submitData = {
            shop_id: this.shopItem.shopOldId,
            vd_id: this.shopItem.vd.oldId,
            launcher_value: {
              // 浏览器核心
              browser_core: this.controller.browser_core,
              // 是否是隐私模式
              is_hide: this.controller.privacy_mode,
              // 选择的cookie和插件加载模式
              choose_modes: this.controller.choose_list
            }
          };
          if (this.controller.choose_list.includes("cookie")) {
            submitData.launcher_value.load_cookie = true;
          } else {
            submitData.launcher_value.load_cookie = false;
          }
          if (this.controller.choose_list.includes("extension")) {
            submitData.launcher_value.load_extension = true;
          } else {
            submitData.launcher_value.load_extension = false;
          }
          yield API.post(`api://base.local/websockets/main`, {
            model: "virtualBrowser.hide_launcher",
            value: submitData
          });
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: this.shopItem.vd.oldId,
              shop_id: this.shopItem.shopOldId,
              new_vd: this.shopItem.vd.id,
              new_shop_id: this.shopItem.id
            }
          });
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  close() {
    this.dialog.visible = false;
    this.controller.browser_core = "chrome";
    this.controller.privacy_mode = true;
    this.controller.choose_list = [];
  }
};
__decorateClass([
  Debounce(600)
], PrivacyModeDialog.prototype, "close", 1);
PrivacyModeDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      chromeIcon,
      chromeActiveIcon,
      firefoxIcon,
      firefoxActiveIcon,
      UiSubmit
    }
  })
], PrivacyModeDialog);
export {
  PrivacyModeDialog as default
};
